/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface TwoFactorTokenverification$Params {
  OTPNo?: string | null;
  Key?: string | null;
}

export function twoFactorTokenverification(http: HttpClient, rootUrl: string, params?: TwoFactorTokenverification$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, twoFactorTokenverification.PATH, 'get');
  if (params) {
    rb.query('OTPNo', params.OTPNo, {});
    rb.query('Key', params.Key, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

twoFactorTokenverification.PATH = '/2factor/tokenVerification';
